module.exports = __webpack_public_path__ + "static/media/walking_man_prac.1d984004.svg";